import React from "react";
import {ReactComponent as Support} from "../../assets/svg/ways/support.svg";
import {ReactComponent as Faq} from "../../assets/svg/ways/faq.svg";
import {ReactComponent as Omomi} from "../../assets/svg/ways/omomi.svg";
import {ReactComponent as VideoSupport} from "../../assets/svg/ways/vsupport.svg";
import {Link} from "react-router-dom";


const HelpTop = ()=>{
    const items = [
        {
            title:'راهنمای متنی',
            icon:Support,
            link:"/support/text"
        },
        {
            title:'راهنمای ویدیویی',
            icon:VideoSupport,
            className:"blue-item",
            link:"/support/video"
        },
        {
            title:'آموزش های عمومی',
            icon:Omomi,
            className: "green-item",
            link:"/support/general"
        },
        {
            title:'سؤالات متداول',
            icon:Faq,
            className: "red-item",
            link:"/support/faq"
        }
    ]
    return(
        <div className='help-top-warp'>
            <div className='bellmeet-useage'>
                <ul className='slide-track'>
                    {items.map((item,key)=>{
                        const Icon = item.icon
                        return(
                            <Link to={item.link} key={key}>
                                <li key={key} className={item.className}>
                                    <div className='icon-svg'>
                                        <Icon/>
                                    </div>
                                    <h4>{item.title}</h4>
                                </li>
                            </Link>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default HelpTop